//Components
import Layout from '../../hocs/Layout';
import { connect } from 'react-redux';
import { useEffect, useState, useRef } from 'react';
import { ShopCard } from '../../components/cards/ShopCard';
import { prices } from '../../helpers/fixedPrices';
import { materials } from '../../helpers/materialType';
import { Disclosure } from '@headlessui/react';
import { useParams } from 'react-router';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
//Redux
import { useSelector } from 'react-redux';
import { get_categories } from '../../redux/actions/categories';
import { get_products } from '../../redux/actions/products';
import { get_items, get_total, get_item_total, add_item } from '../../redux/actions/cart';
import { get_product_categories } from '../../redux/actions/categories';
//Styles
import '../../styles/products.css';
//Icons
import { FaAngleRight, FaAngleLeft } from "react-icons/fa6";
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';


const Shop = ({
	get_categories,
	categories,
	get_products,
	products,
	get_items,
	get_total,
	get_item_total,
	add_item,
}) => {

	const params = useParams();
  	const navigate = useNavigate();
	const location = useLocation();
	const [searchParams] = useSearchParams();
	const categoryName = params.categoryName
	const [categoryId, setCategoryId] = useState(null);
	const productsState = useSelector(state => state.Products);
	const [filterByCategory, setFilterByCategory] = useState(false);
	const [filterByAnother, setFilterByAnother] = useState(false);
	const [searchProduct, setSearchProduct] = useState('');
	const searchFormRef = useRef();
	const [page, setPage] = useState(1);
	const filters = {
	    category: searchParams.get("category"),
	    price_min: searchParams.get("price_min"),
	    price_max: searchParams.get("price_max"),
	    rating_min: searchParams.get("rating_min"),
	    rating_max: searchParams.get("rating_max"),
	    material: searchParams.get("material"),
	    discount: searchParams.get("discount"),
	}
	const sort = {
		sortBy: searchParams.get("sortBy"),
		order: searchParams.get("order"),
	}

	useEffect(() => {
		window.scrollTo(0,0)
		get_categories()
	}, []);

	useEffect(() => {
    	get_products(filters, sort, page)	
  	}, [searchParams, page])

  	const handleFiltersSortChange = (newFilters) => {
	  	const params = new URLSearchParams(location.search);

	  	// Agregamos/actualizamos los nuevos filtros
	  	Object.entries(newFilters).forEach(([key, value]) => {
	    	params.set(key, value);
	  	});

	  	// Navegamos con los filtros actualizados
	  	navigate(`${location.pathname}?${params.toString()}`);
	};

	const addToCart = async (product) => {
	    if (product && product !== null && product !== undefined && product.quantity > 0) {
	        await add_item(product);
	        await get_items();
	        await get_total();
	        await get_item_total();
	    }
	}

	const showProducts = () => {
		let display = []
		let items = [];

        if (products) {
            items = Array.isArray(products) ? products : [];
        }

		if (items && items.length > 0 && categories) {
            items.forEach((product, index) => {
				display.push(
					<div key={index} className='product-card-wrapper'>
						<ShopCard product={product} variants={product.variants} />
					</div>
				);
			})
		}
		return display;
	}

	const handleNextPage = () => {
        if (productsState.next) {
            setPage(page + 1);
        }
    };

    const handlePreviousPage = () => {
        if (productsState.previous && page > 1) {
            setPage(page - 1);
        }
    };

	return (
		<Layout>
			<div className='container-banner-all shop'>
				<h3>Todos los productos</h3>
			</div>
			<div className='container-categories-shop'>
				{categories && categories.map((category, index) => {
					return (
						<button className='container-category-shop' key={index} onClick={() => handleFiltersSortChange({ category: category.id })}>
							<img src={category.thumbnail} alt={`Category ${index}`} />
							<p>{category.name}</p>
						</button>
					)
				})}
			</div>
			<div className='container-filters'>
				<div className='container-filter-products'>
					<Disclosure as="div" className='contain-disclosure'>
	          			{({ open }) => (
	            			<>
	              				<Disclosure.Button className='disclosure-filter'>
	                				<span>Precio</span>
	                				{open ? <FaChevronUp /> : <FaChevronDown />}
	              				</Disclosure.Button>
	              				<Disclosure.Panel className='disclosure-panel'>
	                				<button 
	                					onClick={() => handleFiltersSortChange({ price_min: 1000, price_max: 20000 })}
	                					className='filter-button'>$ 1.000 - $ 20.000</button>
	                				<button 
	                					onClick={() => handleFiltersSortChange({ price_min: 21000, price_max: 40000 })}
	                					className='filter-button'>$ 21.000 - $ 40.000</button>
	                				<button 
	                					onClick={() => handleFiltersSortChange({ price_min: 41000, price_max: 60000 })}
	                					className='filter-button'>$ 41.000 - $ 60.000</button>
	                				<button 
	                					onClick={() => handleFiltersSortChange({ price_min: 61000, price_max: 80000 })}
	                					className='filter-button'>$ 61.000 - $ 80.000</button>
	                				<button 
	                					onClick={() => handleFiltersSortChange({ price_min: 80000 })}
	                					className='filter-button'>Más de $ 80.000</button>
	              				</Disclosure.Panel>
	            			</>
	          			)}
	        		</Disclosure>
	        		<Disclosure as="div" className='contain-disclosure'>
	          			{({ open }) => (
	            			<>
	              				<Disclosure.Button className='disclosure-filter'>
	                				<span>Material</span>
	                				{open ? <FaChevronUp /> : <FaChevronDown />}
	              				</Disclosure.Button>
	              				<Disclosure.Panel className='disclosure-panel'>
	                				{materials && materials.map((material, index) => {
	                						return (
	                							<div className='input-category-wrapper' key={index}>
	                								<button
	                									onClick={() => handleFiltersSortChange({ material: material.value })}
	                									className='filter-button'
	                								>{material.name}</button>
	                							</div>
	                						)
	                					})
									}
	              				</Disclosure.Panel>
	            			</>
	          			)}
	        		</Disclosure>
	        		<Disclosure as="div" className='contain-disclosure'>
	          			{({ open }) => (
	            			<>
	              				<Disclosure.Button className='disclosure-filter'>
	                				<span>Ordenar</span>
	                				{open ? <FaChevronUp /> : <FaChevronDown />}
	              				</Disclosure.Button>
	              				<Disclosure.Panel className='disclosure-panel'>
									<button className='filter-button' onClick={() => handleFiltersSortChange({sortBy:'final_price', order: 'asc'})}>
										Menor Precio
									</button>
									<button className='filter-button' onClick={() => handleFiltersSortChange({sortBy:'final_price', order: 'desc'})}>
										Mayor Precio
									</button>
									<button className='filter-button' onClick={() => handleFiltersSortChange({sortBy:'sold', order: 'desc'})}>
										Más Vendidos
									</button>
									<button className='filter-button' onClick={() => handleFiltersSortChange({sortBy:'name', order: 'asc'})}>
										Alfabético: A - Z
									</button>
									<button className='filter-button' onClick={() => handleFiltersSortChange({sortBy:'name', order: 'desc'})}>
										Alfabético: Z - A
									</button>
									<button className='filter-button' onClick={() => handleFiltersSortChange({sortBy:'date_created', order: 'desc'})}>
										Reciente
									</button>
									<button className='filter-button' onClick={() => handleFiltersSortChange({sortBy:'date_created', order: 'asc'})}>
										Más Antiguo
									</button>
	              				</Disclosure.Panel>
	            			</>
	          			)}
	        		</Disclosure>
				</div>
				</div>
			<div className='container-product-pagination'>
				<div className='container-shop'>
					{products && showProducts()}
				</div>
				<div className="pagination-controls">
                	<button className='pagination-button' onClick={handlePreviousPage} disabled={!productsState || (productsState.previous === null&& page === 1)}>
                    	<FaAngleLeft className='pagination-button-icon' />Anterior
                	</button>
                	<button className='pagination-button' onClick={handleNextPage} disabled={!productsState || productsState.next === null}>
                    	Siguiente <FaAngleRight className='pagination-button-icon' />
                	</button>
            	</div>
			</div>
		</Layout>
	);
};

const mapStateToProps = state => ({
	categories: state.Categories.categories,
	products: state.Products.products,
	count: state.Products.count,
	next: state.Products.next,
	previous: state.Products.previous,
})

export default connect(mapStateToProps, {
	get_categories,
	get_products,
	get_items,
	get_total,
	get_item_total,
	add_item,
}) (Shop)